'use client';

import { useState, useEffect } from 'react';

/**
 * Hook to detect if debug mode is enabled
 * Safe for use in client components
 */
export function useDebugMode(): boolean {
  const [debugMode, setDebugMode] = useState(false);
  
  useEffect(() => {
    // Check environment variable
    const envDebug = process.env.NEXT_PUBLIC_DEBUG_MODE === 'true';
    
    // Check URL parameter (if implemented)
    const urlDebug = new URLSearchParams(window.location.search).get('debug') === 'true';
    
    // Check localStorage (if implemented)
    const localDebug = localStorage.getItem('debug_mode') === 'true';
    
    setDebugMode(envDebug || urlDebug || localDebug);
  }, []);
  
  return debugMode;
}